import { render, staticRenderFns } from "./StudentProfileCourseVideos.vue?vue&type=template&id=733f7b83&scoped=true"
import script from "./StudentProfileCourseVideos.vue?vue&type=script&lang=js"
export * from "./StudentProfileCourseVideos.vue?vue&type=script&lang=js"
import style0 from "./StudentProfileCourseVideos.vue?vue&type=style&index=0&id=733f7b83&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733f7b83",
  null
  
)

export default component.exports